/**
 * Cart Bundle Handler
 * Handles removing entire bundles from cart
 */

class CartBundleHandler {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const removeBtn = event.target.closest('[data-bundle-remove]');
    if (removeBtn) {
      event.preventDefault();
      const bundleContainer = removeBtn.closest('[data-bundle-id]');
      if (bundleContainer) {
        const bundleId = bundleContainer.dataset.bundleId;
        this.removeBundle(bundleId);
      }
    }
  }

  async removeBundle(bundleId) {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find all items with this bundle_id
      const updates = {};
      
      cart.items.forEach((item) => {
        // Check if item has bundle properties
        const isBundleItem = item.properties && 
          item.properties['_bundle'] === 'true' && 
          item.properties['_bundle_id'] === bundleId;
        
        if (isBundleItem) {
          updates[item.key] = 0;
        }
      });
      
      // Check if we found any items to remove
      if (Object.keys(updates).length === 0) {
        console.warn('No bundle items found with ID:', bundleId);
        return;
      }
      
      // Update cart to remove all bundle items
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('Failed to remove bundle');
      }

      const data = await response.json();

      // Trigger cart update event
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "bundle_remove",
          cartData: data
        });
      }

      // Refresh mini-cart
      const miniCart = document.querySelector('mini-cart');
      if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
        const sections = miniCart.getSectionsToRender().map((section) => section.section);
        const cartDataResponse = await fetch(`${window.location.pathname}?sections=${sections.join(',')}`);
        const cartSections = await cartDataResponse.json();
        miniCart.renderContents({ sections: cartSections });
      } else {
        // Fallback: reload page
        window.location.reload();
      }

    } catch (error) {
      console.error('Error removing bundle:', error);
      alert('There was an error removing the bundle. Please try again.');
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CartBundleHandler());
} else {
  new CartBundleHandler();
}

/**
 * Remove every bundle line from the cart, used before adding a non-bundle product so
 * the cart drawer's 10%/15% stacking milestones can apply normally afterward.
 * Returns true if any bundle items were removed.
 */
window.removeBundlesFromCart = async function removeBundlesFromCart() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const updates = {};
    cart.items.forEach((item) => {
      if (item.properties && item.properties._bundle === 'true') {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return false;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      console.warn('removeBundlesFromCart: cart update failed', response.status);
      return false;
    }

    return true;
  } catch (error) {
    console.error('removeBundlesFromCart error:', error);
    return false;
  }
};

/**
 * Remove every non-bundle line from the cart (the mirror of removeBundlesFromCart).
 * Called before adding a new bundle so cart is exclusively bundle-only. Also clears
 * any orphaned free-gift items so the new bundle's free gift isn't duplicated.
 * Returns true if any items were removed.
 */
window.removeStandaloneFromCart = async function removeStandaloneFromCart() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const updates = {};
    cart.items.forEach((item) => {
      const isBundleItem = item.properties && item.properties._bundle === 'true';
      if (!isBundleItem) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return false;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      console.warn('removeStandaloneFromCart: cart update failed', response.status);
      return false;
    }

    return true;
  } catch (error) {
    console.error('removeStandaloneFromCart error:', error);
    return false;
  }
};